import React, {useState, useEffect, Fragment} from 'react';
//import {t} from '../../utils/functions';
import flatstore from 'flatstore';
import Button from '../../components/forms/button';
import AnimalFill from '../../components/ui/AnimalFill';
import AnimalTag from '../../components/ui/AnimalTag';
import ProductContent from '../../components/ui/ProductContent';
//import ProductContent2 from '../../components/ui/ProductContent2';
import ProfileFarmer from '../../components/ui/ProfileFarmers';
import ProfileBuyer from '../../components/ui/ProfileBuyer';
import PackagePricePerMealPerPerson from '../../components/ui/PackagePricePerMealPerPerson';
import Price from '../../components/ui/Price';
import Loader from '../../components/ui/Loader';
import moment from 'moment/min/moment-with-locales';
import {isEmpty, mapValues, upperFirst, isNil, last, includes} from "lodash";
import parse from 'html-react-parser';
import LoadModules from '../../components/ui/LoadModules';
import {getProductInfoSync} from '../../utils/services';
import {siteInfo} from '../../utils/config';
import {currentLang, productURL, animalPercent} from '../../utils/functions';
import Meta from '../../components/ui/Meta';
import { useTranslation } from 'react-i18next';
import Slider from '../../components/ui/Slider';
import NotFound from '../static/404';
import W from '../../components/ui/Word';
import ProductNewsletter from '../../components/ui/ProductNewsletter';
import { Link, useHistory, useLocation } from 'react-router-dom';

const ProductDetail = ({slug, loading, product_data, err_data}) => {
    const [data, setData] = useState(null);
    const [modules, setModules] = useState(0);
    const [shopURL, setShopURL] = useState(null);
    const [btnDisable, setBtnDisable] = useState(false);
    const [variations, setVariations] = useState(null);
    const [loadingClass, setLoadingClass] = useState(false); //loading-opacity
    const [forceUpdate, setForceUpdate] = useState(true);
    const [activeVariation, setActiveVariation] = useState(null);
    const [showPercentMessage, setShowPercentMessage] = useState(false);
    const [moduleData, setModuleData] = useState(null);
    const [productPackages, setProductPackages] = useState(null);
    const [processedChecklist, setProcessedChecklist] = useState(null);
    const { t, i18n } = useTranslation();
    const history = useHistory();
    const {pathname} = useLocation();
    const animals = siteInfo[currentLang()]['animal_types'];

    useEffect(() => {
        product_data = null;
        window.scrollTo(0, 0);
    }, [])


    useEffect(() => {

        if(history.action == "POP"){

            slug = last(window.location.href.replace(/\/$/, "").split('/'));
            
            product_data = null;
            setData(null);
            setShowPercentMessage(false);
            setForceUpdate(true);
            
            if(data)
                getProductInfoSync(slug);
            /*if(activeVariation){
                getProductInfoSync(slug);
            }*/
        }
    }, [pathname])

	useEffect(() => {

		if (isNil(product_data) && slug) {
            getProductInfoSync(slug);
        }
        if(forceUpdate && product_data){
            product_data.shop_product_percentage_sold  = animalPercent(product_data.shop_product_percentage_sold);
            setData(product_data);
            setProductPackages(product_data.packages);
            setModules(product_data.modules);
            //console.log("product_data slug: "+product_data.slug);
            var mdata = {
                "farmer_image_url":product_data.farmer_image_url,
                "farmer_header_image_url":product_data.farmer_header_image_url,
                "farmer_title":product_data.farmer_title,
                "farmer_location":product_data.farmer_location,
                "farmer_slug":product_data.farmer_slug,
                "farmer_is_new":product_data.farmer_is_new,
                "shop_brand_slug":product_data.shop_brand_slug,
                "animal":product_data.shop_brand_slug
            };
            setModuleData(mdata);
            setForceUpdate(false);
        }
    }, [product_data]);

    useEffect(() => {
        if(data){
            //console.log(data);
            setTimeout(()=>{setShowPercentMessage(true)}, 4000);
            setLoadingClass(false);
            if(Array.isArray(window.dataLayer) && window.dataLayer.length > 0){
                window.dataLayer.map((item, index)=>{
                    if(item.productInfo){
                        delete window.dataLayer[index];
                    }
                })
            }
            window.dataLayer = window.dataLayer || [];
            var dataLayerProductData = {
                'category_slug':data.category_slug,
                'package_slug':data.package_slug,
                'product_id':data.product_id,
                'relation_slug':data.relation_slug,
                'slug':data.slug,
                'title':data.title,
                'variation_slug':data.variation_slug,
                'shop_product_id':data.shop_product_id,
                'shop_package_price':data.shop_package_price,
                'shop_package_id':data.shop_package_id,
                'shop_package_frontend_size':data.shop_package_frontend_size,
                'shop_brand_slug':data.shop_brand_slug,
                'shop_animal_brand':data.shop_animal_brand,
                'shop_product_title':data.shop_product_title,
            }
            //console.log();
            window.dataLayer.push({
                'productInfo': dataLayerProductData,
                'event':'grutto-product-view'
            });

        }
        if(data){
            //console.log("data-slug: "+data.slug);
            setProductPackages(data.packages);
            if(data.modules){
                    setModules(data.modules);
                    var mdata = {
                        "farmer_image_url":data.farmer_image_url,
                        "farmer_header_image_url":data.farmer_header_image_url,
                        "farmer_title":data.farmer_title,
                        "farmer_location":data.farmer_location,
                        "farmer_slug":data.farmer_slug,
                        "farmer_is_new":data.farmer_is_new,
                        "shop_brand_slug":data.shop_brand_slug,
                        "animal":product_data.shop_brand_slug
                    };
                setModuleData(mdata);
            }
            //console.log(data.modules);
        }

        if(data && data.package_variations && !isEmpty(data.package_variations) && data.package_variations.length > 1){
            //console.log(data.package_variations);
            data.package_variations[0].variation_active_slug = data.slug;
            setVariations(data.package_variations)
        }
    }, [data])

    useEffect(() => {
        //console.log(modules, moduleData);
    }, [moduleData, modules])

    useEffect(() => {
        if ( data ) {
            if ( data.product_shop_delivery_week && data.product_shop_delivery_year && data.shop_product_stock_status == "instock" && t('estimated_delivery_date') != 'estimated_delivery_date' && t('estimated_delivery_date_format') != 'estimated_delivery_date_format' ) {
                moment.locale(siteInfo[currentLang()]['locale'])
                var estimated_delivery_date_day = t('estimated_delivery_date_day') != 'estimated_delivery_date_day' ? t('estimated_delivery_date_day') : '5';
                var estimated_delivery_date_format = moment().year(data.product_shop_delivery_year).week(data.product_shop_delivery_week).day(estimated_delivery_date_day).format(t('estimated_delivery_date_format'));
                var estimated_delivery_date = t('estimated_delivery_date',{estimated_delivery_date_format});
                //estimated_delivery_date = '<li><i class="icon-calendar"></i>' + estimated_delivery_date + '</li>';
            } else {
                var estimated_delivery_date = '';
            }
            if ( data.checklist ) {
                setProcessedChecklist(data.checklist.replaceAll( '__estimated_delivery_date__', estimated_delivery_date ));
            }
        }
    }, [data]);

    const changeVariation = (value) =>{

        setProductPackages(null);
        setShowPercentMessage(false);
        setLoadingClass(true);
        setActiveVariation(value);
        setForceUpdate(true);
        getProductInfoSync(value);


    }
    const handleBasket = (value) =>{
        if(value == 0){
            setBtnDisable(true);
        }else{
            setBtnDisable(false);
        }
    }

    const createURL = (params) => {

        if(params){
            var url_params = "";
            if(!isEmpty(params)){
                mapValues(params, (value, key)=>{
                    url_params += "&"+key+"="+value;
                });
            }
            var tmpURL = "/"+currentLang()+"/shop/order-package/?category="+data.category_slug
                        +"&path="+t("menu.products")+"/"+data.slug;

            if(JSON.parse(data.shop_package_attributes) != undefined){
                var attr = JSON.parse(data.shop_package_attributes);
                for(var aKey in attr){
                    tmpURL += "&"+aKey+"="+attr[aKey];
                }
            }
            tmpURL += url_params;

            setShopURL(tmpURL);
        }
    }

    return (
        <Fragment>
        {!data && err_data && err_data == '404' &&
            <NotFound />
        }
        {data &&
            <Fragment>
                {moduleData &&
                    <div>
                    <LoadModules modules={modules} product={data} moduleKey={slug} moduleData={moduleData} type="top" />
                    </div>
                }
                <Meta
                    title={data.seo_title ? data.seo_title : data.title}
                    description={data.seo_description && data.seo_description}
                    type="product"
                    type_data={data}
                    image={data.image_url}
                />
                <div className={"container mt-40 package--" + data.shop_brand_slug + (data.is_organic == 1 || data.is_demeter == 1 ? " package--bio" : "") + (data.is_msc == 1 ? " package--msc" : "") + (data.is_special == 1 ? " package--special" : "")}>

                {data.package_variations && !isEmpty(data.package_variations) && data.package_variations.length > 1 &&
                    <div className="row">
                        <div className="col-xxl-6 offset-xxl-3 col-xl-8 offset-xl-2 offset-lg-1 col-lg-10 col-md-12">
                            <div className="button-group__holder">
                                <div className="button-group">
                                {data.package_variations.map((item, index) => {
                                    var variationClass = 'button-group__item button-group--blue';
                                    if((data.slug == item.package_variation_slug && !loadingClass) || (loadingClass && activeVariation == item.package_variation_slug))
                                        variationClass = 'button-group__item button-group--red active'
                                    return (
                                        <Fragment>
                                            <Link key={index} to={productURL(t('menu.products'), item.package_variation_slug, data.shop_brand_slug)} onClick={()=>{changeVariation(item.package_variation_slug)}} className={variationClass}>{item.package_variation_title}</Link>
                                        </Fragment>
                                    )
                                })}
                                </div>
                            </div>
                        </div>
                    </div>
                }


                <div className={"package__title mt-40"+(loadingClass ? " loading-opacity" : "")}>
                    <h1 className="heading heading--h2 text-center">
                        {data.title}
                        {(data.is_organic == 1 || data.is_demeter == 1) &&
                            <span className="text--green bio"><W>general.organic</W></span>
                        }
                        {(data.is_special == 1) &&
                            <span className="text--red special"><W>product.special</W></span>
                        }
                    </h1>
                    <div className="package__info">
                        <ul className="list list--no-list text-center">
                            {isNil(data.meatcut_pieces_suffix) &&
                                <li>{data.shop_package_count} <W>product.differentmeatcuts</W></li>
                            }
                            {!isNil(data.meatcut_pieces_suffix) &&
                                <li>{data.shop_package_count} {data.meatcut_pieces_suffix}</li>
                            }
                            <li>{parseInt(data.shop_package_total_meals_for_person)} <W>product.meals</W> / {data.shop_package_frontend_size}</li>
                            <li>{data.additional_info}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className={"container pt-20 pb-40 package__full package--" + data.shop_brand_slug+(loadingClass ? " loading-opacity" : "") + (" " + currentLang())}>
                <div className="row">
                    <div className="col-12 col-md-6">

                        <div className="percentage__box">
                            <AnimalTag
                                country={data.shop_animal_nr_prefix}
                                amount={data.shop_animal_nr}
                            />
                            <AnimalFill
                                percentage={data.shop_product_percentage_sold}
                                animal={data.shop_brand_slug}
                                category_slug={data.shop_category_slug}
                            />

                        </div>

                        <div className="package__spec">
                            <div className="item">
                                <ProfileFarmer
                                    name={data.farmer_name}
                                    title={data.farmer_title}
                                    body={data.farmer_summary}
                                    location={data.farmer_location}
                                    image={data.farmer_image_url}
                                    link={data.farmer_slug}
                                    earnumber={data.shop_animal_nr}
                                    isnew={data.farmer_is_new}
                                    animal={data.shop_brand_slug}
                                    breeds={data.shop_animal_name}
                                />
                            </div>
                            <div className="item">
                                <ProfileBuyer
                                    totalBuyers={data.shop_product_buyer_count}
                                    totalPackages={data.shop_product_total_package_available}
                                    soldPercentage={data.shop_product_percentage_sold}
                                />
                            </div>
                            <div className="item">
                                {
                                <PackagePricePerMealPerPerson
                                    value={data.shop_package_price_per_meals &&data.shop_package_price_per_meals.toFixed(2)}
                                />
                                }
                            </div>
                        </div>

                        <div className={"package__full--gallery " + (data.is_organic == 1 ? 'bio' : '') + (data.is_msc == 1 ? 'msc' : '')}>

                            {data.main_slider &&
                                <Slider data={data.main_slider} sliderType="product" />
                            }
                        </div>
                        {data.body &&
                        <div className="package__full--body">
                            {parse(data.body)}
                        </div>
                        }
                    </div>
                    <div className="col-12 col-md-5 offset-md-1">
                        <div className="row package__order align-items-center mt-30 pt-20 pb-20">
                            <div className="col-6 col-md-12 package__price">
                                {!isNil(data.previous_price) &&
                                    <div className="p-prev">
                                        <Price value={data.previous_price} />
                                    </div>
                                }
                                <div className={"p-main"}>
                                    <Price value={data.shop_package_price} />
                                </div>
                                <div className="package__meal">
                                    {data.shop_package_frontend_size} / {parseInt(data.shop_package_total_meals_for_person)} <W>product.meals</W>
                                </div>
                            </div>
                            <div className="col-6 col-md-12 package__btn">
                                {data.shop_product_stock_status != "instock" &&
                                    <Fragment>
                                    <Button
                                        disable={true}
                                        title={t("shop.status."+data.shop_product_stock_status)}
                                        type="addtocart"
                                        url="#"
                                    />
                                    </Fragment>
                                }
                                {data.shop_product_stock_status == "instock" &&
                                    <Button
                                        disable={btnDisable}
                                        title={t('shop.status.'+data.shop_product_stock_status)}
                                        type="addtocart"
                                        url={shopURL}
                                    />
                                }
                            </div>
                        </div>
                        {/* I know ;) I will refactor it later */}
                        {showPercentMessage && data.shop_product_percentage_sold <= 50 && data.shop_product_stock_status != 'coming_soon' &&
                        <div className="message__urgency success">
                            <div className="status"> <W>product.notification_btn.l50</W> </div>
                            <div className="description">
                              {(i18n.exists('product.notification.'+data.shop_brand_slug)) ? t('product.notification.'+data.shop_brand_slug, {animal_nr: data.shop_animal_nr, percentage: data.shop_product_percentage_sold }) : upperFirst(t(data.shop_brand_slug)) + ' ' + t('product.notification_message', {animal_nr: data.shop_animal_nr, percentage: data.shop_product_percentage_sold })}
                            </div>
                        </div>
                        }
                        {showPercentMessage && data.shop_product_percentage_sold <= 75 && data.shop_product_percentage_sold > 50 && data.shop_product_stock_status != 'coming_soon' &&
                        <div className="message__urgency warning">
                            <div className="status"> <W>product.notification_btn.l75</W> </div>
                            <div className="description">
                               {(i18n.exists('product.notification.'+data.shop_brand_slug)) ? t('product.notification.'+data.shop_brand_slug, {animal_nr: data.shop_animal_nr, percentage: data.shop_product_percentage_sold }) : upperFirst(t(data.shop_brand_slug)) + ' ' + t('product.notification_message', {animal_nr: data.shop_animal_nr, percentage: data.shop_product_percentage_sold })}
                            </div>
                        </div>
                        }
                        {showPercentMessage && data.shop_product_percentage_sold > 75 && data.shop_product_percentage_sold < 100 && data.shop_product_stock_status != 'coming_soon' &&
                        <div className="message__urgency error">
                            <div className="status"> <W>product.notification_btn.l100</W> </div>
                            <div className="description">
                               {(i18n.exists('product.notification.'+data.shop_brand_slug)) ? t('product.notification.'+data.shop_brand_slug, {animal_nr: data.shop_animal_nr, percentage: data.shop_product_percentage_sold }) : upperFirst(t(data.shop_brand_slug)) + ' ' + t('product.notification_message', {animal_nr: data.shop_animal_nr, percentage: data.shop_product_percentage_sold })}
                            </div>
                        </div>
                        }

                        {data.shop_product_stock_status != "instock" &&
                        <div className="row">
                            <div className="col-md-12">

                                {includes(['cow', 'chicken', 'pig', 'deer', 'boar', 'game', 'fish', 'goose', 'duck', 'roe', 'salmon'], data.shop_brand_slug) &&
                                    <ProductNewsletter status={data.shop_product_stock_status} productId={data.mailchimp_id} animaltype={data.shop_brand_slug} />
                                }
                            </div>
                        </div>
                        }

                        <ul className="list list--bold list--icon text--green mt-30">
                            {processedChecklist && parse(processedChecklist)}
                        </ul>

                        {productPackages &&
                            <Fragment>
                                <ProductContent perperson={data.shop_package_price_per_meals} raw_data={data} data={productPackages} handleBasket={handleBasket} createURL={createURL} />
                            </Fragment>
                        }
                        {data.body &&
                            <div className="package__full--body mobile">
                                {parse(data.body)}
                            </div>
                        }

                    </div>
                </div>
            </div>
            {moduleData &&
                <div>
                <LoadModules modules={modules} product={data} moduleData={moduleData} type="bottom" />
                </div>
            }
            </Fragment>
        }

        </Fragment>
    )
}

export default flatstore.connect(['loading', 'product_data', 'err_data'])(ProductDetail);
